import { arrayOf, number } from 'prop-types';

import api from '../REST/api';
import withResolved from '../REST/with-resolved';
import calculateCampaignStatistics from './calculate-campaign-statistics';
import CampaignStatistics from './CampaignStatistics';

const ResolvedCampaignStatistics = withResolved({
  query: args => {
    return Promise.all([
      api.getOpportunities(args),
      api.getCampaigns(args),
    ]).then(([opportunityResponse, campaignsResponse]) =>
      calculateCampaignStatistics(
        campaignsResponse,
        opportunityResponse,
        !!(args.search.brandIds && args.search.brandIds.length),
      ),
    );
  },
  deriveQueryArgs: ({ accountId, brandId }) => ({
    search: { accountId, brandIds: [brandId] },
  }),
  as: 'data',
})(CampaignStatistics);

ResolvedCampaignStatistics.propTypes = {
  accountId: number,
  brandIds: arrayOf(number.isRequired),
};

export default ResolvedCampaignStatistics;
